
export default {
  components: {},
  props: {
    locationLink: {
      type: String,
      default: "#"
    },
    locationImage: {
      type: String,
    },
    locationName: {
      type: String,
      default: 'Place Name'
    },
    locationArea: {
      type: String,
      default: ''
    },
    locationRatings: {
      type: Number,
      default: 0
    },
    locationCity: {
      type: String,
      default: 'City'
    },
    locationCategory: {
      type: String,
      default: 'Category'
    },
    locationBrief: {
      type: String,
      default: 'Description'
    },
    locationDistance: {
      type: Number,
      default: 0
    },
    postIdx: {
      type: Number,
      default: 0
    },
    attractionIdx: {
      type: Number,
      default: 0
    },
    isAttraction: {
      type: Boolean,
      default: false
    },
    attractions:{
      default: ''
    }
  },
  methods: {
    clickPlaces(slug){
      if (localStorage.getItem("plcData")) {
        localStorage.removeItem('plcData');
      }
      this.$router.push({
        path: "/restaurant/" + slug,
      });
    }
  }
}

